import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { GET_CUSTOMER_LIST_REQUEST } from '../constants/customerConstants';
import {
  getCustomerListSuccess,
  getCustomerListFailure
} from '../actions/customerActions';
import { getCustomerListApi } from '../api/customerApi';

function* getCustomerListSaga(action) {
  try {
    const response = yield call(getCustomerListApi, action.payload);
    yield put(getCustomerListSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch customers';
    yield put(getCustomerListFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* customerSaga() {
  yield takeEvery(GET_CUSTOMER_LIST_REQUEST, getCustomerListSaga);
}

export default customerSaga;